import Promise from 'bluebird'
import yamlErrors from '../lib/preparations/yaml-errors.js'

export default function (data) {
  return new Promise((resolve, reject) => {
    resolve( yamlErrors(data) );
  });
};
